import { useCallback, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { getOwnEndUser } from '@idk-web/api';
import { inboxUser, updateUser, type InboxUser } from '@/state/inboxAuth';

export type User = InboxUser & {
  /**
   * Reloads the current user globally
   */
  reload(): Promise<void>;
};

/**
 * Returns the currently logged in inbox user.
 *
 * This hook may only be used in components that are only mounted when an inbox
 * user is guaranteed to be logged in.
 */
export function useInboxUser(): User {
  const user = useAtomValue(inboxUser);
  const reload = useCallback(async () => {
    if (!user) {
      console.warn('Tried to reload user when user is missing in state');
      return;
    }

    const response = await getOwnEndUser();

    updateUser(response);
  }, [user]);

  return useMemo(
    () => ({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ...user!,
      reload,
    }),
    [user, reload],
  );
}
